import Page from "../../common/layout/Page";
import useLeadAutoList, { LeadAutoListProvider } from "./useLeadAutoList";
import useManagers from "../../../hooks/useManagers/useManagers";
import LeadAutoList from "./LeadAutoList/LeadAutoList";
import Pagination from "../../common/Pagination";
import Loader from "../../common/Loader";
import LeadAutoListFilters from "./LeadAutoListFilters/LeadAutoListFilters";

const LEADS_PER_PAGE = 15;

const LeadAutoPage = () => {
  const { actions, leadAutoFilters, nbLead, isLoading } = useLeadAutoList();
  const { managers } = useManagers(true);

  if (managers.length === 0) return <Loader />;

  return (
    <Page
      title="Leads auto"
      subTitle="Demandes de devis d'assurance auto"
      titleMargin="mb-2"
    >
      <LeadAutoListProvider value={{}}>
        <div className="mb-3">
          <LeadAutoListFilters />
        </div>
        <div className="mb-3">
          <Pagination
            page={leadAutoFilters.page}
            nbPages={Math.ceil(nbLead / LEADS_PER_PAGE)}
            changePage={actions.updatePage}
          />
        </div>
        <LeadAutoList isLoading={isLoading} />
        <div className="mt-3">
          <Pagination
            page={leadAutoFilters.page}
            nbPages={Math.ceil(nbLead / LEADS_PER_PAGE)}
            changePage={actions.updatePage}
          />
        </div>
      </LeadAutoListProvider>
    </Page>
  );
};

export default LeadAutoPage;
